import summaryCharts from './summaryCharts';
import groupMeans from './groupMeans';
import footnotes from './footnotes';

export default [summaryCharts, groupMeans, footnotes];
